import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/BreakdownReasonPlaceActions";
import * as api from "../../api/BreakdownReasonPlaceApi";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";


function* getBreakdownReasonPlaces(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getBreakdownReasonPlaces(action.payload);
        yield put(actions.setBreakdownReasonPlace(data.resultObject || undefined));
    } catch (error) {
        yield put(actions.setBreakdownReasonPlace(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlants() {
    try {
        const { data } = yield api.getPlants();
        yield put(actions.setPlants(data || undefined));
    } catch (error) {
        yield put(actions.setPlants(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakdownGroups() {
    try {
        const { data } = yield api.getBreakdownGroups();
        yield put(actions.setBreakdownGroups(data || undefined));
    } catch (error) {
        yield put(actions.setBreakdownGroups(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addBreakdownReasonPlace(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addBreakdownReasonPlace(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateBreakdownReasonPlace(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateBreakdownReasonPlace(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteBreakdownReasonPlace(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteBreakdownReasonGroup(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_BREAKDOWN_REASON_PLACES, getBreakdownReasonPlaces);
    yield takeEvery(actions.Types.GET_PLANTS, getPlants);
    yield takeEvery(actions.Types.GET_BREAKDOWN_GROUPS, getBreakdownGroups);
    yield takeEvery(actions.Types.ADD_BREAKDOWN_REASON_PLACE, addBreakdownReasonPlace);
    yield takeEvery(actions.Types.UPDATE_BREAKDOWN_REASON_PLACE, updateBreakdownReasonPlace);
    yield takeEvery(actions.Types.DELETE_BREAKDOWN_REASON_PLACE, deleteBreakdownReasonPlace);
}

const BreakdownReasonPlaceSaga = [fork(watchAll)];

export default BreakdownReasonPlaceSaga;
